"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useYupForm = void 0;
var react_hook_form_1 = require("react-hook-form");
var yup_1 = require("@hookform/resolvers/yup");
var setAPIError = function (setError) { return function (error) { return setError('APIError', {
    type: error,
}); }; };
var useYupForm = function (schema, props) {
    if (props === void 0) { props = {}; }
    var formReturn = (0, react_hook_form_1.useForm)(__assign({ resolver: (0, yup_1.yupResolver)(schema) }, props));
    return __assign({ setAPIError: setAPIError(formReturn.setError) }, formReturn);
};
exports.useYupForm = useYupForm;
exports.default = exports.useYupForm;
